import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Dashboard.scss";

interface Grievance {
    comments: any;
    created_at: string | number | Date;
    id: number;
    subject: string;
    description: string;
    status: string;
  }
  
  

const Dashboard: React.FC = () => {
    const [grievances, setGrievances] = useState<Grievance[]>([]);
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchGrievances();
  }, []);

  const fetchGrievances = async () => {
    try {
      const response = await axios.get("https://sjmpolytechnicbirur.in/api/get_grievances_id.php", { withCredentials: true });
      if (response.data.success) {
        setGrievances(response.data.grievances);
      }
    } catch (error) {
      toast.error("Failed to load grievances!");
      console.error("Error fetching grievances:", error);
    }
  };

  const submitGrievance = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://sjmpolytechnicbirur.in/api/submit_grievance.php",
        { subject, description },
        { withCredentials: true }
      );
      if (response.data.success) {
        toast.success("Grievance submitted successfully!");
        setSubject("");
        setDescription("");
        fetchGrievances();
      } else {
        toast.error(response.data.message || "Submission failed!");
      }
    } catch (error) {
      toast.error("Error submitting grievance!");
      console.error("Error submitting grievance:", error);
    }
  };
  const handleLogout = async () => {
    try {
      await fetch("http://sjmpolytechnicbirur.in/api/logout.php", { credentials: "include" }); // Call PHP logout
      localStorage.removeItem("user"); // Remove user data from localStorage
      window.location.href = "/login"; // Redirect to login page
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <div className="dashboard-container">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="dashboard-header">Student Dashboard</div>
      <button className="logout-btn" onClick={handleLogout}>
  Logout
</button>
      <div className="dashboard-content">
        {/* Grievance Submission Form */}
        <div className="card grievance-form">
          <h3>Submit a Grievance</h3>
          <form onSubmit={submitGrievance}>
            <input
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
            <textarea
              placeholder="Describe your grievance..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
            <button type="submit">
              <i className="fas fa-paper-plane"></i> Submit
            </button>
          </form>
        </div>

        {/* Submitted Grievances */}
        <div className="card grievances">
          <h3>Your Grievances</h3>
          <div className="grievance-list">
            {grievances.length > 0 ? (
              grievances.map((grievance) => (
                <div key={grievance.id} className="grievance-item">
                  <div className="grievance-header">
                    <span>{grievance.subject}</span>
                    <span className={`status ${grievance.status.toLowerCase()}`}>
                      {grievance.status === "Resolved" ? "✔ Resolved" : "⏳ Pending"}
                    </span>
                  </div>
                  <div className="grievance-body">{grievance.description}</div>
                  <div className="grievance-footer">
                    <span>{new Date(grievance.created_at).toLocaleDateString()}</span>
                    <div className="grievance-comments">
                    <span className="comments">
                      <i className="fas fa-comments"></i> {grievance.comments}
                    </span>
</div>

                  </div>
                </div>
              ))
            ) : (
              <p>No grievances submitted yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
